// extracted by mini-css-extract-plugin
module.exports = {"name":"resourceInfo_name_p3olJWj","timings":"resourceInfo_timings_2SCwWNE"};